module.exports = __webpack_public_path__ + "static/media/blocked_payment.f9fa1704.svg";